<template>
	<div class="row">
    <div class="col-md-12">
      <br><br>
      <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="false">
        <div class="panel panel-default">
            <div class="panel-heading" role="tab" id="headingOne">
                <h4 class="panel-title">
            <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" @click="collapse()">{{ $t('Ver otras ediciones') }}</a>
          </h4>
            </div>
            <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                <div class="panel-body">

                 	<table class="otras-ediciones">
                 		<tr v-for="edicion in ediciones" @click="setOtraEdicion(edicion.id)">
                 			<td><img :src="edicion.imagen" alt="" width="40"></td>
                 			<td class="title plf20">
                        {{ edicion.titulo }} 
                        <span class="bold">{{ (edicion.volumen) ? ' · ' + edicion.volumen : '' }}</span>
                        <span class="bold">{{ (edicion.edicion) ? ' · ' + edicion.edicion : '' }}</span>
                      </td>              			
                 			<td class="grey light">
												<template v-for="(item, index) in edicion.directores">
						              <template v-if="index > 0">, </template>
						              {{ item.nombre }}
						            </template>
                 			</td>                			
                 			<td class="grey light plf20">{{ edicion.ano.nombre }}</td>
                 			<td class="uc bold plf20">{{ edicion.formato.nombre }}</td>
                 			<td class="bold align-right pr10 nowrap">{{ toCurrency(edicion.precio) }}</td>
                 		</tr>
                 	</table>

                </div>
            </div>
        </div>
      </div>
      <br><br>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Ver otras ediciones": "Ver otras ediciones"
  },
  "en": {

  },
  "ca": {
    "Ver otras ediciones": "Veure altres edicions"
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex';

  import FichaBasica from './FichaBasica.vue';

	export default {
		components: { FichaBasica },
    props:['ediciones'],
		data: () => {
			return{
        producto: "",
        loading: false,
        error: false,
        error_message: '',
        otrasEdicionesId: ''
			}
		},
    mounted(){
    	$('.collapse').collapse('hide');
    },
    computed: {},
    methods:{  
    	setOtraEdicion(id){
    		this.$emit('update:otrasEdicionesId', id);
    	},
      collapse(){
        $('.collapse').collapse('toggle');
      }
    }
  }
</script>
